import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=2bde2030&scoped=true&"
import script from "./Signup.vue?vue&type=script&lang=ts&"
export * from "./Signup.vue?vue&type=script&lang=ts&"
import style0 from "./Signup.vue?vue&type=style&index=0&id=2bde2030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde2030",
  null
  
)

export default component.exports